import React from "react";
import { array } from "prop-types";
import { StoryCard } from "@quintype/arrow";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { staticTexts } from "../../../../utils/translate";
import "./related-stories.m.css";
import { getLocalizationConfig } from "../../../../collection-templates/utils";
import { fallbackImageUrl } from "../../../../../constants";

const RelatedStories = ({ relatedStories }) => {
  if (!relatedStories || relatedStories.length < 0) {
    return null;
  }
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const lang = get(qtState, ["config", "publisher-attributes", "lang"], "en");
  const localizationObject = getLocalizationConfig(lang);

  const config = {
    localizationConfig: {
      ...localizationObject,
      showAuthor: false,
      showTime: false,
      showReadTime: false,
    },
    fallbackImageUrl: fallbackImageUrl,
    showSection: false,
  };

  return (
    <div styleName="wrapper" className="related-stories-wrapper">
      <div styleName="heading">{staticTexts(lang).relatedStoriesHeading}</div>
      <div styleName={`stories-wrapper ${lang === "bn" ? "bn-wrapper" : ""}`}>
        {relatedStories.map((item, index) => {
          return (
            <StoryCard
              story={item.story}
              config={config}
              aspectRatio={[[16, 9]]}
              isHorizontalWithImageLast
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

RelatedStories.propTypes = {
  relatedStories: array,
};

export default RelatedStories;
